import styled, { createGlobalStyle } from 'styled-components';
import { colors, mediaQueries, size } from '@everlywell/leaves';

const Layout = styled.div.attrs((props) => ({
  fadeIn: props.fadeIn,
}))`
  display: flex;
  flex-direction: column;
  margin-top: ${size.xl4}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: ${size.xl4 - 6}px;
  }

  *:focus {
    outline-color: ${colors.teal4};
  }
`;

const CheckoutLayout = styled.div`
  background: ${colors.white};

  ${mediaQueries.forTabletHorizontalUp} {
    background: ${colors.green1};
  }
`;

export const SolvvyOverrideStyles = createGlobalStyle`
  #solvvy-v5-widget-container .solvvy-v5-widget {
    opacity: 1 !important;
    pointer-events: initial;
  }
`;
export const SolvvyHiddenStyles = createGlobalStyle`
  #solvvy-v5-widget-container .solvvy-v5-widget {
    opacity: 0 !important;
    pointer-events: none;
  }
`;

export { Layout, CheckoutLayout };
